import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';

const CompleteProfileModal = () => {
  const [show, setShow] = useState(true);
  const history = useHistory();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleProfileNavigation = () => {
    history.push('/profile');
    handleClose();
  };

  return (
    <>
      {/* Complete Profile Modal */}
      <Modal 
        show={show} 
        onHide={handleClose}
        centered
        backdrop="static"
        keyboard={false}
        className="complete-profile-modal"
        style={{zIndex: 10000}}
      >
        <Modal.Header className="warning-header border-0 pb-2">
          <Modal.Title className="warning-title">
            <div className="warning-icon">
              <i className="fas fa-exclamation-triangle"></i>
            </div>
            <span>Profile Incomplete</span>
          </Modal.Title>
        </Modal.Header>
        
        <Modal.Body className="warning-body text-center py-4">
          <div className="warning-content">
            <div className="warning-shield mb-4">
              <img src="/warning-triangle.png" alt="Warning" className="warning-image" />
            </div>
            <h4 className="warning-heading mb-3">Complete Your Profile to Continue</h4>
            <p className="warning-text mb-4">
            Your profile setup is incomplete. Please verify your email address and complete all required information including TAN and MSME details to access all features and start selling.
            </p>
           
          </div>
        </Modal.Body>
        
        <Modal.Footer className="warning-footer border-0 pt-0 justify-content-center">
          <Button 
            onClick={handleProfileNavigation}
            className="warning-button px-5 py-2"
          >
            <i className="fas fa-user-edit me-2"></i>
            Complete Profile Now
          </Button>
        </Modal.Footer>
      </Modal>

      <style jsx>{`
        .complete-profile-modal .modal-content {
          border: none;
          border-radius: 15px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
          overflow: hidden;
        }
        
        .warning-header {
          background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
          color: white;
          padding: 20px 30px 15px;
          text-align: center;
        }
        
        .warning-title {
          font-size: 20px;
          font-weight: 600;
          margin: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          width: 100%;
        }
        
        .warning-icon {
          font-size: 24px;
          color: #fff;
          animation: pulse 2s infinite;
        }
        
        .warning-body {
          background: #fff;
          padding: 30px;
        }
        
        .warning-content {
          max-width: 400px;
          margin: 0 auto;
        }
        
        .warning-shield {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        
        .warning-image {
          width: 60px;
          height: 60px;
          opacity: 0.8;
          animation: bounce 2s infinite;
        }
        
        .warning-heading {
          color: #333;
          font-size: 22px;
          font-weight: 600;
          margin-bottom: 15px;
        }
        
        .warning-text {
          color: #666;
          font-size: 16px;
          line-height: 1.6;
          margin-bottom: 25px;
        }
        
        .warning-features {
          display: flex;
          flex-direction: column;
          gap: 10px;
          margin-bottom: 20px;
        }
        
        .feature-item {
          display: flex;
          align-items: center;
          gap: 10px;
          color: #555;
          font-size: 14px;
        }
        
        .feature-item i {
          color: #28a745;
          font-size: 16px;
        }
        
        .warning-footer {
          background: #f8f9fa;
          padding: 20px 30px;
        }
        
        .warning-button {
          background: linear-gradient(135deg, #165B5B 0%, #227C7B 100%);
          border: none;
          border-radius: 25px;
          font-size: 16px;
          font-weight: 600;
          padding: 12px 30px;
          color: white;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(22, 91, 91, 0.3);
        }
        
        .warning-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(22, 91, 91, 0.4);
          background: linear-gradient(135deg, #227C7B 0%, #165B5B 100%);
        }
        
        .warning-button:focus {
          box-shadow: 0 0 0 3px rgba(22, 91, 91, 0.2);
        }
        
        @keyframes pulse {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.1);
          }
          100% {
            transform: scale(1);
          }
        }
        
        @keyframes bounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }
        
        /* Responsive Design */
        @media (max-width: 768px) {
          .warning-header {
            padding: 15px 20px 10px;
          }
          
          .warning-title {
            font-size: 18px;
          }
          
          .warning-body {
            padding: 20px;
          }
          
          .warning-heading {
            font-size: 20px;
          }
          
          .warning-text {
            font-size: 14px;
          }
          
          .warning-button {
            font-size: 14px;
            padding: 10px 25px;
          }
        }
      `}</style>
    </>
  );
};

export default CompleteProfileModal;